import { displayCriteriaFields, netOrderAmountTypeByMatchType } from './constants'

export const getDeliveryMethodsPayload = deliveryMethods => {
  return deliveryMethods?.map((deliveryMethod, index) => ({
    position: index,
    enabled: deliveryMethod.is_enabled,
    id: deliveryMethod.id,
  }))
}

const getNetOrderAmount = displayCriteria => {
  const criterion = displayCriteria?.find(criterion => criterion.field === displayCriteriaFields.orderNetValue)
  const type = netOrderAmountTypeByMatchType[criterion?.match_type]

  return type ? { type, amount: criterion.match_value } : null
}

export const getDeliveryMethodsWithNetOrderAmount = deliveryMethods => {
  return deliveryMethods?.map(deliveryMethod => {
    if (!deliveryMethod.display_criteria) return deliveryMethod

    return { ...deliveryMethod, net_order_amount: getNetOrderAmount(deliveryMethod.display_criteria) }
  })
}
